<!-- //
表单设计列表
@auth xuyd
@date 2024-05-01
//-->
<template>
  <page-layout layout="C">
    <div class="layout-function" style="justify-content: space-between;align-items: center;">
      <el-form @submit.native.prevent ref="refForm" :model="queryParams" size="small" :inline="true" label-width="100px">
        <el-form-item prop="pageName">
          <el-input
              v-model="queryParams.pageName"
              placeholder="请输入表单名称"
              style="width: 300px;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button size="small" type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
        <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus">新建表单</el-button>
      </div>
    </div>
    <!-- 结果区域 -->
    <div class="layout-result" style="height: 100%;margin-top: 5px;">
      <el-table ref="refTable" v-loading="tableLoading" :data="list"
                border
                stripe
                height="600"
                size="small"
                :header-cell-style="this.tableHeader">
        <el-table-column header-align="center" label="No." align="center" width="70" type="index"/>
        <el-table-column header-align="left" label="表单名称" align="left" min-width="180" prop="pageName" />
        <el-table-column header-align="left" label="组件个数" align="left" min-width="100" prop="widgetCount" />
        <el-table-column header-align="left" label="有效状态" align="left" min-width="100" prop="status">
          <template slot-scope="{row}">
            <dict-tag dictType="YES_OR_NO" :value="row.status" :options="{type: 'tag'}" />
          </template>
        </el-table-column>
        <el-table-column header-align="left" label="操作" align="left" width="250">
          <template slot-scope="{row}">
            <el-button type="text" class="el-icon-delete button" @click="handleDelete(row)">删除</el-button>
            <el-button type="text" class="el-icon-view button" @click="handlePreview(row)">预览</el-button>
            <el-button type="text" class="el-icon-edit button" @click="handleDesign(row)">设计</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="total" :pageNum.sync="queryParams.pageNum" :pageSize.sync="queryParams.pageSize"
                  @pagination="getList"/>
    </div>
    <AddDlg ref="refAddDlg"/>
  </page-layout>
</template>

<script>
import DataFormApi from '@/api/datavisual/dataForm.api.js';
import AddDlg from './add';

export default {
  name: 'ViewFormList',
  components: {AddDlg},
  dictTypes:[
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {
      list: [],
      total: 0,
      tableLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageName: null,
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      DataFormApi.searchFormList(this.queryParams).then(resp => {
        this.list = resp.data.records;
        this.total = resp.data.total;
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm('refForm');
      this.handleQuery();
    },

    /**
     * 新增
     */
    handleAdd() {
      this.$refs.refAddDlg.showModal({
        data: {},
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 编辑
     */
    handleEdit(row) {
      this.$refs.refAddDlg.showModal({
        data: {...row},
        onOk: (data) => {
          this.getList();
        }
      });
    },

    /**
     * 预览
     * @param row
     */
    handlePreview(row) {
      let routeData = this.$router.resolve({name: 'ViewFormPreview'});
      window.open(routeData.href + '?pageId=' + row.id, '_blank');
    },

    /**
     * 删除
     * @param row
     */
    handleDelete(row) {
      this.$modal.confirm(`确定要删除【${row.pageName}】吗？`).then(() => {
        DataFormApi.deleteForm(row.id).then(resp => {
          this.$modal.msgSuccess('删除成功');
          this.getList();
        })
      })
    },

    /**
     * 跳转
     * @param row
     */
    handleDesign(row) {
      let routeData = this.$router.resolve({name: 'ViewFormDesign',});
      window.open(routeData.href + '?pageId=' + row.id, '_blank');
    }
  }
}
</script>


<style lang="less" scoped>

.button {
  cursor: pointer;
  margin: 0 10px;
  font-size: 12px;
}
</style>
